import * as React from "react";
const WatchDemoSVG = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.513 5.56445H9.1351C5.9009 5.56445 4.2838 5.56445 3.37545 6.51016C2.46709 7.45588 2.68081 8.91695 3.10825 11.8392L3.5136 14.6102C3.84881 16.9019 4.01641 18.0477 4.87622 18.7338C5.73602 19.42 7.00416 19.42 9.54042 19.42H15.1076C17.644 19.42 18.9121 19.42 19.7719 18.7338C20.6318 18.0477 20.7993 16.9019 21.1345 14.6102L21.5399 11.8392C21.9673 8.91705 22.181 7.45587 21.2727 6.51016C20.3643 5.56445 18.7472 5.56445 15.513 5.56445ZM14.7977 13.4728C15.3328 13.1411 15.3328 12.2822 14.7977 11.9506L11.5666 9.94745C11.0465 9.62506 10.4074 10.0447 10.4074 10.7087V14.7147C10.4074 15.3786 11.0465 15.7983 11.5666 15.4759L14.7977 13.4728Z"
      fill="#888E9E"
    />
  </svg>
);
export default WatchDemoSVG;
